import { ICardData } from 'types/types';

import { axiosInstance } from './axiosInstance';

export const MyCards = {
  getCardsData: async (): Promise<ICardData> => {
    return axiosInstance.get('cards/get');
  },
};
